const getUserListResponse = (response) => {
  const totalData = response?.totalData ?? 0;
  const totalPage = response?.totalPage ?? 0;
  const isDataExist = response?.isDataExist;

  const users = response?.users?.map((item) => {
    return {
      id: item?.id ?? '-',
      name: item?.name ?? '-',
      nip: item?.nip ?? '-',
      email: item?.email ?? '-',
      brands: item?.brands?.map((brand) => brand?.name ?? '-')?.join(', ') || '-',
      platform: item?.ecommerces?.map((ecommerce) => ecommerce?.name ?? '-')?.join(', ') || '-',
      role: item?.role?.name ?? '-',
      handphone: item?.handphone ?? '-',
      isActive: item?.isActive,
      rawData: item,
    };
  });

  return { users, totalData, totalPage, isDataExist };
};

export default getUserListResponse;
